<template>
  <ion-page>
    <main-header>
      <ion-toolbar>
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-searchbar
                inputmode="search"
                @ionChange="search"
              ></ion-searchbar>
            </ion-col>
            <ion-col>
              <ion-select
                placeholder="Role"
                value
                @ionChange="roleFiltered"
                class="next-to-search"
              >
                <ion-select-option value>All Roles</ion-select-option>
                <ion-select-option
                  v-for="claim in CLAIMS"
                  v-bind:key="`claim-${claim}`"
                  :value="claim"
                  >{{ claim | ucfirst }}</ion-select-option
                >
              </ion-select>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-toolbar>
    </main-header>
    <ion-content padding>
      <loading-spinner v-if="loading"></loading-spinner>
      <div v-else>
        <div
          v-if="!users.length"
          class="background-color ion-color-warning ion-padding ion-text-center"
        >
          There are no users available.
        </div>
        <div
          v-else-if="!filteredUsers.length"
          class="background-color ion-color-warning ion-padding ion-text-center"
        >
          There are no users found.
        </div>
        <div v-else>
          <ion-list>
            <ion-item
              v-for="user in filteredUsers"
              v-bind:key="`user-${user.id}`"
              detail="true"
              button
              @click="navigateToUser(user.id)"
              :data-cy="`user-${user.id}`"
            >
              <ion-avatar slot="start">
                <img :src="user.photoURL" />
              </ion-avatar>
              <ion-label>
                <h2>
                  {{ user.displayName }}
                  <ion-badge v-if="!user.displayName">None</ion-badge>
                </h2>
                <h3>{{ user.email }}</h3>
              </ion-label>
              <ion-badge
                v-if="user.customClaims.admin"
                slot="end"
                color="danger"
                >Admin</ion-badge
              >
              <ion-badge
                v-if="user.customClaims.user"
                slot="end"
                color="success"
                >User</ion-badge
              >
              <ion-badge
                v-if="user.customClaims.runner"
                slot="end"
                color="secondary"
                >Runner</ion-badge
              >
              <ion-badge
                v-if="user.customClaims.vendor"
                slot="end"
                color="tertiery"
                >Vendor</ion-badge
              >
            </ion-item>
          </ion-list>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { CLAIMS } from "@/constants/claims";
import errorAlert from "@/ErrorAlert";
import User from "@/models/User";
import { mapGetters } from "vuex";

const maxUsers = 5000;

export default {
  title: "Users",
  data: function() {
    return {
      CLAIMS,
      loading: true,
      users: [],
      searchTerm: "",
      roleFilter: ""
    };
  },

  methods: {
    roleFiltered(event) {
      this.roleFilter = event.detail.value;
    },

    search(event) {
      this.searchTerm = event.detail.value;
    },

    navigateToUser(uid) {
      this.$router.push({
        name: "Web: User Edit",
        params: {
          uid
        }
      });
    }
  },

  created() {
    if (!this.userIsAdmin) {
      return this.$router.push("/").catch(e => e);
    }

    this.$firestore()
      .collection("users")
      .withConverter(User.firebaseConverter)
      .orderBy("email")
      .limit(maxUsers)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.users.push(doc.data());
        });
      })
      .catch(e => {
        errorAlert(e.message);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  computed: {
    ...mapGetters("auth", ["userIsAdmin"]),

    filteredUsers() {
      let filtered = this.users;

      if (this.roleFilter) {
        filtered = filtered.filter(user => user.customClaims[this.roleFilter]);
      }

      if (this.searchTerm) {
        let term = this.searchTerm.toLowerCase();

        filtered = filtered.filter(
          user =>
            (user.displayName &&
              user.displayName.toLowerCase().indexOf(term) > -1) ||
            (user.email && user.email.toLowerCase().indexOf(term) > -1)
        );
      }

      return filtered;
    }
  }
};
</script>
